export const SET_LAYOUT = 'SITE/SET_LAYOUT'
export const UPDATE_LOADING = 'SITE/UPDATE_LOADING'
export const UPDATE_TITLE = 'SITE/UPDATE_TITLE'
export const UPDATE_DESC = 'SITE/UPDATE_DESC'
export const UPDATE_SITE_IMAGE = 'SITE/UPDATE_SITE_IMAGE'
export const UPDATE_SITE_URL = 'SITE/UPDATE_SITE_URL'
export const UPDATE_BACKDROP = 'SITE/UPDATE_BACKDROP'
export const UPDATE_ISMOBILE = 'SITE/UPDATE_ISMOBILE'
export const UPDATE_KEYWORDS = 'SITE/UPDATE_KEYWORDS'
